import { useStaticQuery, graphql } from 'gatsby'
export const ArticlesList = () => {
  const { allMysqlArticles } = useStaticQuery(
    graphql`
      query ArticlesListData {
        allMysqlArticles {
          articleslist: edges {
            node {
              id
              articleid
              ArticleContent
              Title
              PageTitle
              ShortDescription
              ArticleIntro
              sort
            }
          }
        }
      }
    `
  )
  return allMysqlArticles
}
